import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Main from './pages/Main';
import Profile from './pages/profile';
import Social from './pages/social';
import NotFound from './pages/NotFound';
import Test from './pages/Test';
import AdminApp from './pages/admin/AdminApp';
import MountainCom from './component/MountainCom';
import SkyCom from './component/SkyCom';

function AppContent() {
    const location = useLocation();
    const contentBox = useRef(null);
    const [position, setPosition] = useState(0);
    const [count, setCount] = useState({ page: 'main' });

    const thisPageState = (pageNum) => { setCount({ page: pageNum, conBox: contentBox }); };
    const mianControl = ["kLayout", ("type_" + count.page), "", ""];
    mianControl[2] = position > 10 ? "scroll" : "";
    mianControl[3] = position > 389 ? "fixed" : "";

    function onScroll() {
        setPosition(contentBox.current.scrollTop);
    }
    function menuClick() {
        contentBox.current.scrollTo({ top: 0, behavior: 'auto' });
    }

    useEffect(() => {
        // admin 페이지에는 contentBox가 없으므로 guard
        if (!contentBox.current) return;
        contentBox.current.addEventListener("scroll", onScroll);
        return () => {
            if (contentBox.current) contentBox.current.removeEventListener("scroll", onScroll);
        };
    });

    // /admin 경로는 별도 레이아웃으로 분리
    if (location.pathname.startsWith('/admin')) {
        return <AdminApp />;
    }

    return (
        <div className={mianControl.join(" ")}>
            <SkyCom />
            <MountainCom />
            <h1 className="mainTitle">
                <span>Light and Space</span>
                <strong>Dreaming in Simulacre</strong>
            </h1>
            <nav className="gnbMenu">
                <h1><Link to="/"><img src="../../logo.svg" alt="" /></Link></h1>
                <Link to="/photo/main" onClick={() => menuClick()}>Photo</Link>
                <Link to="/art/2017" onClick={() => menuClick()}>Art</Link>
                <Link to="/profile/main" onClick={() => menuClick()}>Profile</Link>
                <Link to="/social/main" onClick={() => menuClick()}>Social</Link>
            </nav>
            <div className="contentBox" ref={contentBox}>
                <Routes>
                    <Route path="/" exact={true} element={<Main pageN={count} pageF={thisPageState} />} />
                    <Route path="/photo/:pageNum" element={<Test pageN={count} pageF={thisPageState} pageScroll={position} />} />
                    <Route path="/art/:pageNum" element={<Test pageN={count} pageF={thisPageState} pageScroll={position} />} />
                    <Route path="/profile/:pageNum" element={<Profile pageN={count} pageF={thisPageState} />} />
                    <Route path="/social/:pageNum" element={<Social pageN={count} pageF={thisPageState} />} />
                    <Route path="/test/:category" element={<Test pageN={count} pageF={thisPageState} pageScroll={position} />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
            <div className="copyBox">
                <p><img src="../../name.svg" alt="Kang, deok won" /></p>
                ⓒ 2023. Kang, deokwon All pictures cannot be copied without permission.
            </div>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent />
        </BrowserRouter>
    );
}

export default App;
